import { useState } from 'react';
import { ExpertLinkCard } from '@/components/ExpertLinkCard';
import { LinkManager } from '@/components/LinkManager';
import { useUIStore } from '@/state/store';

/** Welle 9 — Experten-Link-Verwaltung: Erstellung (persönlich/Gruppe) + Liste mit Widerruf. */
export function LinksView() {
  const setView = useUIStore((s) => s.setView);
  const [refresh, setRefresh] = useState(0);

  return (
    <div className="dashboard view active">
      <div className="greeting">
        <div className="greeting-left">
          <div className="hi-eyebrow">Verwaltung</div>
          <div className="hi-name">Experten-<strong>Links</strong></div>
        </div>
        <div className="greeting-right">
          <button
            onClick={() => setView('dashboard')}
            style={{
              background: 'transparent', border: '1px solid var(--hairline, #232323)', color: 'var(--muted, #8aa)',
              borderRadius: 8, padding: '8px 14px', fontSize: 12, fontWeight: 600, cursor: 'pointer',
              fontFamily: 'inherit', letterSpacing: '.04em',
            }}
          >← Zurück zum Dashboard</button>
        </div>
      </div>

      <div style={{ display: 'grid', gridTemplateColumns: 'minmax(320px, 460px) 1fr', gap: 24, alignItems: 'start' }}>
        <ExpertLinkCard onCreated={() => setRefresh((n) => n + 1)} />
        <LinkManager refreshSignal={refresh} />
      </div>
    </div>
  );
}
